const events = {
  // + Событие нажатие на лого “Jet - Wi-Fi”
  CLICK_LOGO_JET_HEADER: {
    event: 'logo_click_jetwifi',
    category: 'jet_wifi',
    action: 'click',
    label: 'JetWiFi',
    nonInteraction:'true'
  },

  // + Событие нажатие на лого “Huawei”
  CLICK_LOGO_HUAWEI_HEADER: {
    event: 'logo_click_huawei',
    category: 'huawei',
    action: 'click',
    label: 'huawei_company',
    nonInteraction:'true'
  },

  // + Событие нажатие на кнопку “Пройти тест”
  CLICK_START_QUIZ: {
    event: 'click_buttontest_start',
    category: 'click_buttonStart',
    action: 'click',
    label: 'start',
    nonInteraction:'true'
  },

  // + Событие нажатие на кнопку “Следующий вопрос” после 3 вопроса
  CLICK_CONTINUE_QUIZ_MIDDLE: {
    event: 'click_buttontest_middle',
    category: 'click_buttonMiddle',
    action: 'click',
    label: 'start',
    nonInteraction:'true'
  },

  // Событие нажатие на кнопку “Узнать результат”
  CLICK_SHOW_RESULTS: {
    event: 'click_buttontest_finish',
    category: 'click_buttonFinish',
    action: 'click',
    label: 'finish',
    nonInteraction:'true'
  },

  // + Событие нажатие на кнопку “Пройти заново”
  CLICK_RESTART_QUIZ: {
    event: 'click_buttontest_again',
    category: 'click_buttonAgain',
    action: 'click',
    label: 'again',
    nonInteraction:'true'
  },

  // + Событие нажатие на кнопку в форме записи “Отправить”
  FORM_SENT: {
    event: 'click_buttonform',
    category: 'click_button',
    action: 'click',
    label: 'form',
    nonInteraction:'true'
  },

  // + Событие “Share Facebook”
  CLICK_SHARE_FACEBOOK: {
    event: 'share_fb',
    category: 'share_facebook',
    action: 'click',
    label: 'fb',
    nonInteraction:'true'
  },

  // + Событие “Share Vkontakte”
  CLICK_SHARE_VK: {
    event: 'share_vk',
    category: 'share_vk',
    action: 'click',
    label: 'vk',
    nonInteraction:'true'
  },

  // + Событие “Share Twitter”
  CLICK_SHARE_TWITTER: {
    event: 'share_tw',
    category: 'share_twitter',
    action: 'click',
    label: 'twitter',
    nonInteraction:'true'
  },

  // + Событие “Share Telegram”
  CLICK_SHARE_TELEGRAM: {
    event: 'share_tlg',
    category: 'share_telegram',
    action: 'click',
    label: 'telegram',
    nonInteraction:'true'
  }
}

export default {
  install (Vue) {
    Vue.prototype.$metrics = {
      events,
      pushEvent (options, customOptions = {}) {
        if (options) {
          window.dataLayer.push({ ...options, ...customOptions })
        } else {
          console.error(`Metrics: event ${name} not found`)
        }
      },
    }
  }
}
